<template>
  <div class="v-input v-text-field theme--light">
    <div class="v-input__control">
      <div class="v-input__slot">
        <div class="v-text-field__slot">
          <label
            class="v-label theme--light"
            aria-hidden="true"
            style="left: 0px; right: auto; position: absolute;"
          >
          </label>
          <vue-google-autocomplete
            id="map"
            placeholder="Address"
            v-on:placechanged="getAddressData"
          >
          </vue-google-autocomplete>
        </div>
      </div>
      <div class="v-text-field__details">
        <div class="v-messages theme--light">
          <div class="v-messages__wrapper"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { mapGetters } from "vuex";
export default {
  props: ["initAddress"],
  data() {
    return {
      Address: {
        address: null,
        city: null,
        stateID: null,
        zipCode: null,
        country: null,
        latitude: null,
        longitude: null
      }
    };
  },
  mounted() {
    $("#map").val(this.initAddress);
  },
  components: {
    VueGoogleAutocomplete
  },
  computed: {
    ...mapGetters("global", ["states"])
  },
  methods: {
    getAddressData(addressData, placeResultData) {
      // console.log('addressData', addressData)
      // console.log('placeResultData', placeResultData)
      this.Address.zipCode = addressData.postal_code;
      this.Address.country = addressData.country;
      this.Address.address = `${addressData.street_number} ${addressData.route}`;
      $("#map").val(this.Address.address);
      this.Address.latitude = addressData.latitude;
      this.Address.longitude = addressData.longitude;
      placeResultData.address_components.map(route => {
        if (route.types[0] === "neighborhood") this.Address.city = route.long_name;
        if (route.types[0] === "administrative_area_level_1") {
          this.states.map(s => {
            if (s.stateSymbol === route.short_name) this.Address.stateID = s.stateID;
          });
        }
      });
      this.$emit("addressSubmit", this.Address);
    }
  }
};
</script>

<style scoped></style>
